<template>
  <!-- 弹出框 -->
  <a-modal
    v-model="modal.visible"
    :title="modal.title"
    @ok="handleOk"
    @cancel="cancel"
    :confirm-loading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="formData"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-model-item label="类型">
        <a-radio-group name="radioGroup" v-model="formData.type">
          <a-radio value="password">密码</a-radio>
          <a-radio value="email_verify_code">邮箱验证码</a-radio>
          <a-radio value="mobile_verify_code">手机验证码</a-radio>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item
        label="原登录密码"
        prop="password"
        v-if="formData.type == 'password'"
      >
        <a-input v-model="formData.password" type="password" :maxLength="20" />
      </a-form-model-item>

      <a-form-model-item
        label="邮箱"
        prop="email"
        v-if="formData.type == 'email_verify_code'"
        ><a-input v-model="formData.email" :disabled="true"
      /></a-form-model-item>

      <a-form-model-item
        label="手机号"
        prop="mobile"
        v-if="formData.type == 'mobile_verify_code'"
        ><a-input v-model="formData.mobile" :disabled="true"
      /></a-form-model-item>

      <a-form-model-item
          label="图片验证码"
          prop="captchaCode"
          v-if="formData.type != 'password'"
      >
        <div style="display: flex;flex-direction: row;">
          <a-input v-model="formData.captchaCode" :maxLength="20" />
          <img width="150" height="32" style="margin-left: 5px;" :src="caImageSrc"/>
          <a-button @click.stop.prevent="getCaImage">刷新</a-button>
        </div>
      </a-form-model-item>

      <a-form-model-item
        label="验证码"
        prop="verifyCode"
        v-if="formData.type != 'password'"
      >
        <div style="display: flex;flex-direction: row;">
          <a-input v-model="formData.verifyCode" :maxLength="20" />
          <a-button
            :disabled="state.smsSendBtn"
            @click.stop.prevent="getCaptcha"
            v-text="(!state.smsSendBtn && '获取验证码') || state.time + ' s'"
          ></a-button>
        </div>
      </a-form-model-item>

      <a-form-model-item label="新登录密码" prop="newPassword"
        ><a-input v-model="formData.newPassword" type="password" :maxLength="20"
      /></a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: "Password",
  data() {
    let handleMobile = (rule, value, callback) => {
      const mobileRegex = /^[1]([3-9])[0-9]{9}$/.test(value);
      if (!mobileRegex) {
        callback("请输入正确的手机号");
      }
      callback();
    };
    let handleEmail = (rule, value, callback) => {
      const emailRegex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(
        value
      );
      if (!emailRegex) {
        callback("请输入正确的邮箱");
      }
      callback();
    };
    return {
      confirmLoading: false,
      //弹出框参数
      modal: {
        visible: false,
        title: "修改密码"
      },
      caImageSrc: "",
      //form
      formData: {
        type: "password"
      },
      //form rules
      rules: {
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "change"
          }
          // { validator: handleMobile, trigger: "blur" }
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "change"
          }
          // { validator: handleEmail, trigger: "blur" }
        ],
        captchaCode: [
          {
            required: true,
            message: "请输入图片验证码",
            trigger: "change"
          }
        ],
        verifyCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "change"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入旧密码",
            trigger: "change"
          }
        ],
        newPassword: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "change"
          }
        ]
      },
      userInfo: null,
      state: {
        time: 60,
        smsSendBtn: false,
        verifyNo: ""
      }
    };
  },
  watch:{
    "formData.type": {
      handler(val) {
        if(val == 'email_verify_code' || val == 'mobile_verify_code'){
          this.getCaImage();
        }
      },
    }
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
  },
  methods: {
    show() {
      this.modal.visible = true;
      this.formData.userNo = this.userInfo.userNo;
      if (this.userInfo.mobile) {
        const reg = /(\d{3})\d{4}(\d{4})/;
        let mobile = this.userInfo.mobile;
        this.formData.mobile = mobile.replace(reg, "$1****$2");
      }
      if (this.userInfo.email) {
        const reg = /(.{2}).+(.{2}@.+)/g;
        let email = this.userInfo.email;
        this.formData.email = email.replace(reg, "$1****$2");
      }
    },
    cancel() {
      this.$refs.ruleForm.resetFields();
      this.formData = {
        type: "password"
      };
      this.confirmLoading = false;
      this.modal.visible = false;
    },
    /**
     * 保存
     */
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.confirmLoading = true;
          let param = {};
          param.userNo = this.formData.userNo;
          param.newPassword = this.formData.newPassword;
          param.type = this.formData.type;
          if (this.formData.type == "password") {
            param.password = this.formData.password;
          } else {
            if (this.formData.type == "email_verify_code") {
              param.email = this.userInfo.email;
            } else if (this.formData.type == "mobile_verify_code") {
              param.mobile = this.userInfo.mobile;
            }
            param.verifyNo = this.state.verifyNo;
            param.verifyCode = this.formData.verifyCode;
          }
          this.$http.loginBksApi.changeUserPassword(param).then(res => {
            if (res && res.result == 0) {
              this.$message.success(res.msg);
              this.cancel();
            } else {
              this.confirmLoading = false;
            }
          });
        } else {
          this.confirmLoading = false;
        }
      });
    },
    /**
     * 发送验证码
     * @param {Object}
     */
    getCaptcha(e) {
      e.preventDefault();
      this.state.smsSendBtn = true;
      const interval = window.setInterval(() => {
        if (this.state.time-- <= 0) {
          this.state.time = 60;
          this.state.smsSendBtn = false;
          window.clearInterval(interval);
        }
      }, 1000);

      const hide = this.$message.loading("验证码发送中..", 0);
      const param = {};
      if (this.formData.type == "email_verify_code") {
        param.account = this.userInfo.email;
        param.accountType = "EMAIL";
      } else if (this.formData.type == "mobile_verify_code") {
        param.account = this.userInfo.mobile;
        param.accountType = "SMS";
      } else {
        this.$message.error("不支持的验证码类型");
        setTimeout(hide, 1);
        clearInterval(interval);
        this.state.time = 60;
        this.state.smsSendBtn = false;
        return;
      }
      param.isCheckUser = "T";
      param.verifyType = "modify_password";
      param.captchaCode = this.formData.captchaCode;
      this.$http.loginBksApi
        .sendVerify(param)
        .then(res => {
          setTimeout(hide, 1);
          if (res && res.result == 0) {
            this.state.verifyNo = res.resultObject;
            this.$notification["success"]({
              message: "提示",
              description: "验证码发送成功",
              duration: 8
            });
          } else {
            setTimeout(hide, 1);
            clearInterval(interval);
            this.state.time = 60;
            this.state.smsSendBtn = false;
          }
        })
        .catch(err => {
          setTimeout(hide, 1);
          clearInterval(interval);
          this.state.time = 60;
          this.state.smsSendBtn = false;
        });
    },
    async getCaImage(){
      let imgUrl = await this.$http.loginBksApi.getCaptcha();
      if(imgUrl){
        this.caImageSrc = imgUrl;
      }
    },
  }
};
</script>

<style></style>
